import { useState, useEffect } from 'react'
import { NetworkStatus } from '@apollo/client'
import { useRolesQuery, Role } from '../../../../graphql'

import {
	EuiFlexGroup,
	EuiFlexItem,
	EuiPageSection,
	EuiSpacer,
} from '@equipmentshare/ds2'

import RolesList from './components/RolesList'
import PermissionsTable from './components/PermissionsTable'

export default function Roles() {
	const [ selectedRole, setSelectedRole ] = useState<Role | undefined>()
	const { data, loading, refetch, networkStatus } = useRolesQuery( { notifyOnNetworkStatusChange: true } )

	const roles = data?.roles as Role[] ?? []
	const isLoading = loading || networkStatus === NetworkStatus.refetch

	useEffect( () => {
		if ( selectedRole ) {
			const updatedRole = data?.roles.find( ( r ) => r?.id === selectedRole?.id )
			if ( updatedRole ) {
				setSelectedRole( updatedRole as Role )
			}
		}
	}, [ data, selectedRole ] )

	const fullHeight = 'eui-fullHeight'

	return (
		<EuiPageSection className={fullHeight} paddingSize="none">
			<EuiSpacer />
			<EuiFlexGroup className={fullHeight}>
				<EuiFlexItem grow={false}>
					<RolesList
						isLoading={isLoading}
						selectedRole={selectedRole}
						setSelectedRole={setSelectedRole}
						roles={roles}
						refetchRoles={refetch}
					/>
				</EuiFlexItem>
				<EuiFlexItem>
					{ selectedRole !== undefined && (
						<PermissionsTable
							selectedRole={selectedRole}
						/>
					) }
				</EuiFlexItem>
			</EuiFlexGroup>
		</EuiPageSection>
	)
}
